import * as React from 'react';
import CouponRegisterModal from './modal';
import CouponRegisterHook from './hook';
import MaskedInput from 'react-maskedinput';
import { Link } from 'react-router-dom';
import icon2 from '../../img/icon2.png';
import Loading from '../../components/loading';
import { FaCaretDown } from 'react-icons/fa'

export default function CouponRegisterPage() {
    const {
        request,
        fieldsInvalid,
        loadingCoupon,
        loadingPersonValidation,
        loadingResponsableValidation,
        messageInvalidCoupon,
        handleChange,
        showSucess,
        setShowSucess,
        loading,
        skus,
        states,
        errorMessage,
        submitCoupon,
        getInvalidFieldsMessages,
        checkFormValidity,
        isSubmitted,
        setIsSubmitted

    } = CouponRegisterHook();



    const handleSubmit = async (e: React.FormEvent) => {

        e.preventDefault();
        setIsSubmitted(true);
        const isValidForm = checkFormValidity();

        if (!isValidForm) {
            getInvalidFieldsMessages();
            return;
        }
        await submitCoupon();
    };

    return (
        <div className="header__form">
            <Link to="/" className="header__logo-1">
                <img src={icon2} alt="icon2" />
            </Link>
            <p className="p-text">
                Preencha os dados abaixo para validar o seu cupom
            </p>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <input
                        id="coupom"
                        type="text"
                        placeholder="N° do cupom"
                        onChange={handleChange}
                        className={isSubmitted && fieldsInvalid.coupom ? "error" : ""}
                        value={request.coupom}
                        maxLength={15}
                    />
                    {messageInvalidCoupon && <span className="text-danger">{messageInvalidCoupon}</span>}
                    {loadingCoupon && <span className="text-primary">Validando...</span>}
                </div>
                <div className="form-group">
                    <input
                        id="product"
                        type="text"
                        placeholder="Produto"
                        disabled={true}
                        value={request.product}
                    />
                </div>
                <div className="form-group">
                    <select
                        id="skuId"
                        onChange={handleChange}
                        className={isSubmitted && fieldsInvalid.sku ? "error" : ""}
                        defaultValue={request?.skuId || ""}
                    >
                        <option value="0">Benefício</option>
                        {
                            skus &&
                            skus.map(p =>
                                <option key={p.id} value={p.id}>
                                    {p.skuName}
                                </option>)
                        }
                    </select>
                    <span className="arrow-down"><FaCaretDown /></span>
                </div>
                <div className="form-group">
                    <MaskedInput
                        id="cpf"
                        type="text"
                        mask="111.111.111-11"
                        placeholder="CPF do Paciente"
                        onChange={handleChange}
                        className={isSubmitted && fieldsInvalid.cpf ? "error" : ""}
                        value={request.cpf}
                    />
                    {loadingPersonValidation && <span className="text-primary">Validando...</span>}
                </div>

                <div className="form-group">
                    <MaskedInput
                        id="bornDateMask"
                        type="text"
                        mask="11/11/1111"
                        placeholderChar=" "
                        placeholder="Data de nascimento do Paciente"
                        onChange={handleChange}
                        className={isSubmitted && fieldsInvalid.bornDateMask ? "error" : ""}
                        value={request.bornDateMask}

                    />
                    {loadingPersonValidation && <span className="text-primary">Validando...</span>}
                </div>
                <div className="form-group">
                    <MaskedInput
                        id="cpfResponsible"
                        type="text"
                        mask="111.111.111-11"
                        placeholder="CPF do comprador"
                        onChange={handleChange}
                        className={fieldsInvalid.cpfResponsible ? "error" : ""}
                        value={request.cpfResponsible}
                    />
                    {loadingResponsableValidation && <span className="text-primary">Validando...</span>}
                </div>

                <div className="form-group">
                    <MaskedInput
                        id="bornDateMaskResponsible"
                        type="text"
                        mask="11/11/1111"
                        placeholderChar=" "
                        placeholder="Data de nascimento do comprador"
                        onChange={handleChange}
                        className={fieldsInvalid.bornDateMaskResponsible ? "error" : ""}
                        value={request.bornDateMaskResponsible}
                    />
                    {loadingResponsableValidation && <span className="text-primary">Validando...</span>}

                </div>
                <div className="form-sc">
                    <div className="form-group form-select">

                        <select
                            id="crmState"
                            onChange={handleChange}
                            className={isSubmitted && fieldsInvalid.crmState ? "error" : ""}
                            value={request?.crmState || ""}
                        >
                            <option key="0" value="0">UF</option>
                            {
                                states &&
                                states.map(state =>
                                    <option key={state.id} value={state.stateCode}>
                                        {state.stateCode}
                                    </option>)
                            }
                        </select>
                        <span className="arrow-down"><FaCaretDown /></span>

                    </div>
                    {
                        request.crmState == "RJ"
                            ? <div className="form-group input-group mb-3">
                                <span className="input-group-text" id="basic-addon1">52</span>
                                <input
                                    id="crmNumber"
                                    type="text"
                                    placeholder="CRM do médico"
                                    onChange={handleChange}
                                    className={isSubmitted && fieldsInvalid.crmNumber ? "error" : ""}
                                    value={request.crmNumber}
                                />
                            </div>
                            : <div className="form-group">
                                <input
                                    id="crmNumber"
                                    type="text"
                                    placeholder="CRM do médico"
                                    onChange={handleChange}
                                    className={isSubmitted && fieldsInvalid.crmNumber ? "error" : ""}
                                    value={request.crmNumber}
                                />
                            </div>
                    }
                </div>
                <div className="form-check">
                    <input
                        id="agreeTerm"
                        type="checkbox"
                        onChange={handleChange}
                        className={isSubmitted && fieldsInvalid.agreeTerm ? "error" : ""}
                        value={request.agreeTerm}
                        checked={request.agreeTerm === 1}
                    />
                    <label htmlFor="agreeTerm">
                        Declaro que li e aceito os <a target="_blank" href="/REGULAMENTO_PROGRAMA_MOMENTA_MAIS.pdf"> termos de consentimento </a>
                    </label>
                </div>
                <div className="form-sc">
                    <div className="form-group form-button">
                        <button
                            type='submit'
                            className="btn-primary"
                            disabled={loading}
                        >
                            OK
                        </button>
                    </div>
                    <div className="form-group form-message">
                        {
                            errorMessage &&
                            <div className="h4 text-danger">
                                <p>Erro:</p>
                                {errorMessage.split("<br />").map((msg, index) => (
                                    <p key={index}>{msg}</p>
                                ))}

                            </div>
                        }
                    </div>
                </div>
            </form>
            <CouponRegisterModal
                show={showSucess}
                onClick={() => setShowSucess(false)}
            />
            <Loading show={loading} />
        </div>
    );
}

